import { render, staticRenderFns } from "./AuthFooter.vue?vue&type=template&id=9a013742&scoped=true"
import script from "./AuthFooter.vue?vue&type=script&lang=js"
export * from "./AuthFooter.vue?vue&type=script&lang=js"
import style0 from "./AuthFooter.vue?vue&type=style&index=0&id=9a013742&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a013742",
  null
  
)

export default component.exports